// Shared product-tag helpers. Products store tag names (string[]); the managed
// `tags` collection holds one canonical spelling per tag, unique under
// collation { locale: 'en', strength: 2 } (case-insensitive, accent-sensitive).

// Trim, collapse inner whitespace, Unicode NFC. Non-strings become ''.
export const normalizeTagName = (name: unknown): string => {
  if (typeof name !== 'string') return '';
  return name.normalize('NFC').replace(/\s+/g, ' ').trim();
};

// Case-insensitive key matching the tags unique index collation (strength 2).
export const tagKey = (name: unknown): string => normalizeTagName(name).toLocaleLowerCase('en');

// Replace every tag matching one of `from` (case-insensitively) with `to`, then
// drop blanks and case-insensitive duplicates, keeping first-occurrence order.
// Order matters: the shop card badge shows tags[0].
export const replaceTags = (tags: unknown, from: readonly string[], to: string): string[] => {
  const fromKeys = new Set(from.map(tagKey));
  const target = normalizeTagName(to);
  const seen = new Set<string>();
  const result: string[] = [];
  for (const tag of Array.isArray(tags) ? tags : []) {
    let name = normalizeTagName(tag);
    if (fromKeys.has(tagKey(name))) name = target;
    const key = tagKey(name);
    if (!name || seen.has(key)) continue;
    seen.add(key);
    result.push(name);
  }
  return result;
};

// Input bounds enforced by the server tag resolver.
export const MAX_TAG_NAME_LENGTH = 50;
export const MAX_TAGS_PER_PRODUCT = 50;
